var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronEnd = function SvgChevronEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.531 9.467a.747.747 0 0 1 0 1.059l-6 6.003a.75.75 0 0 1-1.06-1.06l5.47-5.468-5.472-5.472a.75.75 0 0 1 1.06-1.06zm-12-6 6 6a.747.747 0 0 1 0 1.059l-6 6.003a.75.75 0 0 1-1.06-1.06l5.47-5.468-5.472-5.472a.75.75 0 0 1 1.06-1.06z"
  })));
};
export default SvgChevronEnd;